/// <amd-module name="typeahead/core/Experiment" />

export class Experiment {
    constructor(public name?: string, public id?: number, public value?: number) {
    }
}
